/// <reference path="custommodal/custommodal.controller.ts" />

module Meevo.Plugins.ControlGallery {
  "use strict";

  // class definition
  class ControlGalleryController {

    datePickerSelectedDate: Date;
    datePickerMinDate: Date;
    datePickerMaxDate: Date;
    spinnerValue: number;
    selectedTime: Date;
    sublistItems;
    selectedGender: Model.GenderEnum;
    inputMaskedTextFieldValue: string;
    passwordMaskedTextFieldValue: string;
    phoneNumberMaskedTextFieldValue: string;
    upperCaseMaskedTextFieldValue: string;
    autoCapitalizationMaskedTextFieldValue: string;
    shortcutMaskedTextFieldValue: string;
    currencyMaskedTextFieldValue: number;
    comboBoxList: any;
    comboBoxValue: any;
    typeAheadModel;
    moverItems = [];
    switchValue: boolean;
    noun: Meevo.Model.NounEnum;
    verb: Meevo.Model.VerbEnum;
    payload: any;

    modalService: Meevo.Components.Modal.IModalService;
    uploadResult: any;

    static $inject = ["meevo.components.modal.ModalService", "$state", "meevo.ContextParams", "$rootScope", "meevo.components.busy.BusyService"];
    fileTypesEnum = Meevo.Model.FileTypes;
    constructor(modalService: Meevo.Components.Modal.IModalService, private $state: ng.ui.IStateService, private contextParams: Meevo.IContextParams, private $rootScope: any, private busyService: Meevo.Components.Busy.IBusyService) {
      //        alert($stateParams);
      let controlGallery = this;
      controlGallery.spinnerValue = 999;
      controlGallery.datePickerSelectedDate = new Date();
      let minDate = moment();
      minDate.add(-1, "M");

      let maxDate = moment();
      maxDate.add(2, "M");

      controlGallery.datePickerMaxDate = maxDate.startOf('day').toDate();
      controlGallery.datePickerMinDate = minDate.startOf('day').toDate();


      var currentDate = moment.utc();
      currentDate.minutes(15);
      controlGallery.selectedTime = currentDate.toDate();

      controlGallery.sublistItems = [{
        name: "Whatever1"
      },
        {
          name: "Whatever2"
        }];

      controlGallery.selectedGender = Model.GenderEnum.Male;

      controlGallery.uploadResult = "assets/images/icons/photo_not_available.svg";

      controlGallery.inputMaskedTextFieldValue = "";
      controlGallery.passwordMaskedTextFieldValue = "";
      controlGallery.phoneNumberMaskedTextFieldValue = "5708079700";
      controlGallery.phoneNumberMaskedTextFieldValue = "5708079700";
      controlGallery.upperCaseMaskedTextFieldValue = "uppercase test";
      controlGallery.autoCapitalizationMaskedTextFieldValue = "new york";
      controlGallery.shortcutMaskedTextFieldValue = "hcm";
      controlGallery.currencyMaskedTextFieldValue = 100;

      controlGallery.comboBoxList = [
        {
          id: 0,
          displayName: "Item 0"
        },
        {
          id: 1,
          displayName: "Item 1"
        },
        {
          id: 2,
          displayName: "Item 2"
        },
        {
          id: 3,
          displayName: "Item 3"
        }
      ];

      controlGallery.comboBoxValue = 0;

      controlGallery.modalService = modalService;
      controlGallery.switchValue = true;

      let payloadObj: any = {};
      payloadObj.id = 12345;
      payloadObj.value = "Event logged from Control Gallery";
      controlGallery.noun = Meevo.Model.NounEnum.Client;
      controlGallery.verb = Meevo.Model.VerbEnum.Created;
      controlGallery.payload = payloadObj;
    }

    alert(message: string): void {
      this.modalService.alert("MESSAGE_MODAL_ALERT_TEST").then((value: any) => { alert(value + " returned"); }, (value: any) => { alert(value + " returned"); });
    }
    testCallback() {
      if (this.contextParams.params.callback) {
        this.$rootScope.$broadcast("closeContext", this.$state.current);
        this.contextParams.params.callback();
        this.$rootScope.$broadcast("gotoState", {
          stateName: this.contextParams.params.callbackState
        });
      } else {
        alert("There's no callback to invoke");
      }
    }
    warning(message: string): void {
      this.modalService.warning("MESSAGE_MODAL_WARNING_TEST").then((value: any) => { alert(value + " returned"); }, (value: any) => { alert(value + " returned"); });
    }

    error(message: string): void {
      this.modalService.error("MESSAGE_MODAL_ERROR_TEST").then((value: any) => { alert(value + " returned"); }, (value: any) => { alert(value + " returned"); });
    }

    confirm(message: string): void {
      this.modalService.confirm("MESSAGE_MODAL_CONFIRM_TEST").then((value: any) => { alert(value + " returned"); }, (value: any) => { alert(value + " returned"); });
    }

    showCustomModal(): void {
      let options: Meevo.Components.Modal.IModalOptions = {
        templateUrl: "app/plugins/controlGallery/customModal/customModal.template.html",
        controller: "meevo.plugins.controlgallery.CustomModalController",
        controllerAs: "vm",
        bindToController: true
      }
      this.modalService.showCustom(options);
    }

   

    // class functions
    filterDeleted(item) {
      return item.stateEnum !== 3;
    }

    testStart() {
      this.busyService.start();
    }

    testStop() {
      this.busyService.stop();
    }
  }

  // controller registration with module
  angular.module("meevo.plugins.controlgallery")
    .controller("meevo.plugins.controlgallery.ControlGalleryController",
    ControlGalleryController);
}
